import { accrochage } from './accrochage/index.js';
import { cartel } from './cartel/index.js';
import { cimaise } from './cimaise/index.js';
export { accrochage } from './accrochage/index.js';
export { cartel } from './cartel/index.js';
export { cimaise } from './cimaise/index.js';
/**
 * Registre des thèmes livrés (section 3.4) : Cimaise, Cartel et Accrochage.
 * Un thème sur mesure est un dossier de plus respectant la même interface.
 */
const REGISTRE = {
    cimaise,
    cartel,
    accrochage,
};
/** Thème par son nom ; lève si le thème n'est pas encore livré. */
export function theme(nom) {
    const trouve = REGISTRE[nom];
    if (trouve === undefined) {
        throw new Error(`Thème non livré : ${nom}. Thèmes disponibles : ${themesLivres().join(', ')}.`);
    }
    return trouve;
}
/** Noms des thèmes réellement disponibles. */
export function themesLivres() {
    return Object.keys(REGISTRE);
}
//# sourceMappingURL=index.js.map